var xss = require('xss');
// FORM SUBMIT

(function ($) {
    $(document).ready(function () {
        $('form').on('submit', function (e) {
            e.preventDefault();

            let name = $('form').find('#name').val();
            let email = $('form').find('#email').val();
            let phone = $('form').find('#telephone').val();
            let range = $('form').find('#range').val();

            let antiSpam = $('form').find('#text').val();

            let data = {
                "name": name,
                "email": email,
                "phone": phone,
            }

            let body = `
            <h3>Name: ${xss(name)}</h3><br />
            <p>E-Mail: ${xss(email)}</p>
            <p>Telefon: ${xss(phone)}</p>

            <p>Stundenvorstellung: ${xss(range)} Std./Woche</p>
            `

            $.ajax({
                type: 'POST',
                url: ajax_url,
                dataType: 'html',
                data: {
                    action: 'submit_form',
                    data: data,
                    body: body,
                    antiSpam: antiSpam,
                },
                success: function (data) {
                    $('#notification__text').html(data);
                    $('.notification-overlay').addClass('active');
                },
                error: function (data) {
                    console.log(data);
                }
            });
        });
    });
})(jQuery);